export default {
  home: {
    title: 'Home',
    welcome: 'Welcome to our website',
    description: 'A modern web application based on Rails and Vue3',
    getStarted: 'Get Started',
    learnMore: 'Learn More'
  },
  header: {
    home: 'Home',
    features: 'Features',
    pricing: 'Pricing',
    about: 'About',
    login: 'Login',
    register: 'Register',
    dashboard: 'Dashboard',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    tiktok: 'TikTok Marketing'
  },
  footer: {
    copyright: 'Copyright',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    contact: 'Contact Us',
    keywords: {
      neural: 'Neural Network',
      machine: 'Machine Learning',
      deep: 'Deep Learning',
      vision: 'Computer Vision',
      nlp: 'NLP',
      mining: 'Data Mining',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      analysis: 'Data Analysis',
      market: 'Marketing',
      content: 'Content Creation',
      creative: 'Creative Design'
    }
  },
  mobile: {
    menu: 'Menu',
    toggleMenu: 'Toggle Menu',
    closeMenu: 'Close Menu',
    openMenu: 'Open Menu'
  },
  pricing: {
    title: {
      main: 'Choose the Plan',
      highlight: 'That Fits You'
    },
    description: 'We offer flexible pricing plans to meet the needs of businesses of all sizes\nYou can upgrade or downgrade your plan at any time',
    plans: {
      basic: {
        name: 'Basic',
        price: '$39.99',
        period: '/month',
        description: 'Perfect for individuals or small teams',
        features: {
          apiCalls: '1,000 API calls per month'
        },
        cta: 'Choose Basic'
      },
      pro: {
        name: 'Professional',
        badge: 'Most Popular',
        price: '$119.99',
        period: '/month',
        description: 'Perfect for medium businesses and professional teams',
        features: {
          apiCalls: '5,000 API calls per month',
          analysis: 'Advanced Data Analysis',
          projects: '20 Projects',
          support: 'Priority Support'
        },
        cta: 'Choose Pro'
      },
      enterprise: {
        name: 'Enterprise',
        price: '$259.99',
        period: '/month',
        description: 'For large enterprises and advanced needs',
        features: {
          apiCalls: 'Unlimited API calls'
        },
        cta: 'Choose Enterprise'
      }
    },
    faq: {
      title: 'FAQ',
      questions: {
        choosePlan: {
          question: 'How do I choose the right plan?',
          answer:
            'You can choose a suitable plan based on your team size and needs. The Basic plan is suitable for individuals or small teams, the Professional plan for medium-sized businesses, and the Enterprise plan for large businesses with special needs. You can upgrade or downgrade your plan at any time.'
        },
        customPlan: {
          question: 'Do you support custom plans?',
          answer: 'Yes, we offer enterprise customization services. If standard plans cannot meet your needs, please contact our sales team and we will tailor a solution for you.'
        },
        apiCount: {
          question: 'How are API calls counted?',
          answer: 'Each request to our server counts as one API call. Our system tracks your usage in real-time, and you can view detailed usage records in the dashboard.'
        },
        refund: {
          question: 'Do you offer refunds?',
          answer:
            'We offer a 7-day money-back guarantee. If you are not satisfied with the service, you can request a full refund within 7 days of purchase. For refunds after 7 days, please contact customer service for assistance.'
        }
      }
    }
  }
}
